// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * Spec 20261028-132500 AC-11: what waits for the Operação in one hospital. Counts and the hospital's name only, so
 * nothing about a patient crosses here; strict, so a field that starts leaking fails here.
 */
export const workQueueRowSchema = z
    .object({
        hospitalId: z.number().int(),
        hospitalName: z.string(),
        acrescimosEmRevisao: z.number().int().nonnegative(),
        solicitacoesRecebidas: z.number().int().nonnegative(),
        retiradasSolicitadas: z.number().int().nonnegative(),
        ocorrenciasAbertas: z.number().int().nonnegative(),
    })
    .strict()
export type WorkQueueRow = z.infer<typeof workQueueRowSchema>

/** GET /api/work-queue: one row per hospital with anything waiting, by name; `hospitalUuid` narrows to one. */
export const workQueueSchema = z
    .object({ rows: z.array(workQueueRowSchema) })
    .strict()
export type WorkQueue = z.infer<typeof workQueueSchema>
